import {baseURL} from './baseURL'
const axios = require('axios')


export const getAilments = (query) => {
    return axios.get(`${baseURL}/api/ailments${query? query: ""}`)
        .then(res => res)
        .catch(err => {
            throw err
        })
}



